import { Component, inject, input, viewChild } from '@angular/core';
import { AddressObject } from '@it2go/types';
import { OrganizationAdministrationAddressesTileStore } from './organization-administration-addresses-tile.store';
import { isAllowed } from '../../../../shared/shared.global-service';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { contentGlobalSuccess } from '../../../content.error';
import { TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { TranslateService } from '@ngx-translate/core';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { UpsertAddressDialogComponent } from '../upsert-address-dialog/upsert-address-dialog.component';
import { MapLinkTagComponent } from '../../../../../components/kit/map-link-tag/map-link-tag.component';

@Component({
    selector: 'app-organization-administration-addresses-tile',
    templateUrl: './organization-administration-addresses-tile.component.html',
    styleUrls: ['./organization-administration-addresses-tile.component.scss'],
    providers: [OrganizationAdministrationAddressesTileStore],
    imports: [
        MapLinkTagComponent,
        CardTableComponent,
    ],
})
export class OrganizationAdministrationAddressesTileComponent {

    public readonly confirm = inject(ConfirmBuilder);
    public readonly store = inject(OrganizationAdministrationAddressesTileStore);
    public readonly dialogService = inject(BaseDialogService);
    public readonly translate = inject(TranslateService);

    public readonly centerId = input(0);
    public readonly addresses = input<AddressObject[]>([]);

    public addressesTable = viewChild<CardTableComponent>(CardTableComponent);

    protected columns = [
        {
            name: 'address',
            type: TableColumnType.MapLink,
        },
        {
            name: 'validFrom',
            type: TableColumnType.Date,
        },
        {
            name: 'validTo',
            type: TableColumnType.Date,
        },
        { name: 'note' },
    ];

    protected async addressDialog(address: AddressObject | null = null): Promise<void> {
        this.dialogService.open(
            UpsertAddressDialogComponent,
            {
                header: this.translate.instant(`database.organizationAdministrationPage.addresses.table.${address ? 'detailTitle' : 'createTitle'}`),
                styleClass: 'p-dialog-width-30',
                data: {
                    centerId: this.centerId(),
                    address,
                },
                focusOnShow: false,
            },
        ).onClose.subscribe((it) => {
            if (it) {
                this.addressesTable()?.reload();
            }
        });
    }

    public async deleteAddress(event: any): Promise<void> {
        this.confirm.confirmDelete(
            () => {
                this.store.api.deleteAddress(event.item.id).then(() => {
                    contentGlobalSuccess.next('common.deleted');
                    this.addressesTable()?.reload();
                });
            },
            event,
        );
    }

    protected readonly isAllowed = isAllowed;

}
